module.exports = __webpack_public_path__ + "img/Kibe51.ebfc9de8.jpg";